import { createSelector } from "reselect";
import { VasState } from "../../store/store-type";
import { AccountObjectQueryFactory } from "../account-object/account-object.query-factory";
import { Membership } from "./membership.model";
import { BaseObjectFilters } from "../../store/bootstrap";
import { dictionarySelector, itemSelector } from "../query-facade";

export class MembershipQueryFactory extends AccountObjectQueryFactory<Membership, BaseObjectFilters> {

    protected _isActiveUserAdmin: (state: VasState) => boolean;
    protected _activeUserMembershipsByAccount: dictionarySelector<Membership>;

    get isActiveUserAdmin(): (state: VasState) => boolean {

        if (!this._isActiveUserAdmin) {
            this._isActiveUserAdmin = createSelector(this.selected, membership => membership.admin);
        }

        return this._isActiveUserAdmin;
    }

    get activeUserMembershipsByAccount(): dictionarySelector<Membership> {

        if (!this._activeUserMembershipsByAccount) {
            this._activeUserMembershipsByAccount = createSelector(this.items, memberships => {
                const result = {};
                memberships.forEach(membership => result[membership.account] = membership);
                return result;
            });
        }

        return this._activeUserMembershipsByAccount;
    }

    get isAdminByAccountUser(): (accountId: string, userId: string) => (state: VasState) => boolean {
        return (accountId: string, userId: string) => createSelector(this.items,
            memberships => !!memberships.find(membership => membership.account === accountId && membership.user === userId && membership.admin)
        );
    }

    get selected(): itemSelector<Membership> {

        if (!this._selected) {

            this._selected = createSelector(
                this.getMemberships,
                this.getSelectedUserId,
                (memberships, userId) => memberships.find(membership => membership.user === userId));
        }

        return this._selected;
    }

    protected getMemberships(state: VasState): Array<Membership> {
        return state.membership.ids.map(id => state.membership.entities[id]);
    }

    protected getSelectedUserId(state: VasState): string {
        return state.user.selected;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/membership/membership.queries.ts